import { sortByBaseAmount } from "views/admin/embrillTable/customSort/customSort";
import { customSortTotalAmount } from "views/admin/embrillTable/customSort/customSort";
import { sortBySgst } from "views/admin/embrillTable/customSort/customSort";
import { customSortInvoiceDate } from "views/admin/embrillTable/customSort/customSort";
import { customSortInvoiceNo } from "views/admin/embrillTable/customSort/customSort";
import { sortByCgst } from "views/admin/embrillTable/customSort/customSort";
import { sortByIgst } from "views/admin/embrillTable/customSort/customSort";
import { customSortDate } from "views/admin/embrillTable/customSort/customSort";
import { customSortPoNo,customSortPurchaseDate,genericSort,customSortApprovedAmount } from "views/admin/embrillTable/customSort/customSort";

export const expenseDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Po No",
      accessor: "poNo",
      sortType:customSortPoNo
    },
    {
      Header: "Order Date",
      accessor: "purchasedate",
      sortType:customSortPurchaseDate

    },
    {
      Header: "Category",
      accessor: "category",
      sortType:genericSort
    },
    {
      Header: "Project",
      accessor: "project",
      sortType:genericSort
    },
    {
      Header: "Major Type",
      accessor: "majorType",
      sortType:genericSort
    },
    {
      Header: "Minor Type",
      accessor: "minorType",
      sortType:genericSort
    },
    {
      Header: "Approved Amount",
      accessor: "approvedAmount",
      sortType:customSortApprovedAmount

    },

  ];

  export const salesDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
   
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      sortType:customSortInvoiceDate

    },
    {
      Header: "Category",
      accessor: "category",
      sortType:genericSort
    },
    {
      Header: "Project",
      accessor: "project",
      sortType:genericSort
    },
    {
      Header: "Major Type",
      accessor: "majorType",
      sortType:genericSort
    },
    {
      Header: "Minor Type",
      accessor: "minorType",
      sortType:genericSort
    },
    {
      Header: "Approved Amount",
      accessor: "approvedAmount",
      sortType:customSortApprovedAmount

    },

  ];

 

  export const salesGstRecordColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      sortType:customSortInvoiceDate
    },
    {
      Header: "Client Name",
      accessor: "client",
      sortType:genericSort
    },
    {
      Header: "GST Number",
      accessor: "gstNumber",
    },
    {
      Header: "Base Amount",
      accessor: "baseAmount",
      sortType:sortByBaseAmount
    },
    {
      Header: "IGST Amount",
      accessor: "igstAmt",
      sortType:sortByIgst
  
    },
    {
      Header: "SGST Amount",
      accessor: "sgstAmt",
      sortType:sortBySgst
    },
    {
      Header: "CGST Amount",
      accessor: "cgstAmt",
      sortType:sortByCgst
  
    },
    {
      Header: "Total GST",
      accessor: "totalGst",
      sortType:customSortTotalAmount
    },
    
    
  ];

  export const salesTdsRecordColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      sortType:customSortInvoiceDate
    },
    {
      Header: "Client Name",
      accessor: "client",
      sortType:genericSort
    },
    {
      Header: "Base Amount",
      accessor: "baseAmount",
      sortType:sortByBaseAmount
    },
    {
      Header: "Percentage",
      accessor: "percentage",
    },
    {
      Header: "Tds Amount",
      accessor: "tdsAmount",
      sortType:sortByIgst
  
    },    
    
  ];


  export const salesPaymentRecordColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Client Name",
      accessor: "client",
      sortType:genericSort
    },
    {
      Header: "Payment Date",
      accessor: "paymentDate",
      sortType:customSortDate
    },
    {
      Header: "Payment ID",
      accessor: "paymentId"
    },
    {
      Header: "Referance No",
      accessor: "referanceNo",
      sortType:sortByBaseAmount
    }, 
    {
      Header: "Payment Mode",
      accessor: "paymentMode",
      sortType:genericSort

    },
    {
      Header: "Bank Charge",
      accessor: "bankCharge",
      sortType:sortByBaseAmount
    },
    {
      Header: "Amount",
      accessor: "amount",
      sortType:sortByBaseAmount
    },
  ];
